export default __webpack_public_path__ + "static/media/movie-night.0d8c5f76.png";